import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment.prod';
import { Router } from '@angular/router';

@Component({
  selector: 'app-page401',
  templateUrl: './page401.component.html',
  styleUrls: ['./page401.component.css']
})
export class Page401Component implements OnInit {

  constructor(private router : Router) { }

  ngOnInit(): void {
  }

  loginAgain() {
    this.router.navigateByUrl("/login");
  }
}
